import React, { useEffect, useState } from "react";
import BackgroundDefault from '../../Assets/Images/background-home-page.png';
import { t } from "i18next";
import '../../Assets/Styles/Customer/customer-info.css';
import { useTranslation } from "react-i18next";
import CustomNav from "../../Components/custom-nav/CustomNav";
import { countTimeExpired } from "../../Services/service";

const CustomerInfo = ({ objectDto, setObjectDto, width, height }) => {
    countTimeExpired(objectDto, setObjectDto);
    const [activeItem, setActiveItem] = useState(null);
    const { i18n } = useTranslation();
    useEffect(() => {
        document.title = "Phu Hung Life"
    }, []);
    useEffect(() => {
    }, [i18n]);
    const divStyle = {
        backgroundImage: `url(${BackgroundDefault})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '100vw',
        height: height,
        backgroundRepeat: 'no-repeat'
    };
    return (
        <div className='nav-container' style={{ height: height }}>
            <CustomNav activeItem={activeItem} setActiveItem={setActiveItem} objectDto={objectDto} setObjectDto={setObjectDto} width={width} height={height} />
            <div className="customer-info-container" style={divStyle}>
                {/* <CustomChangeLanguage /> */}
                <div className='title-home-page-customer-info' style={{ textAlign: "center" }}>
                    <p style={{ textAlign: "initial", margin: "0" }}>{t("homepagetitle1")}</p>
                    <p style={{ paddingLeft: "14%", textAlign: "initial" }}>{t("homepagetitle2")}</p>
                    <label className="label-title-home-page">
                        {t("homepagetitle3")}<br />
                        {t("homepagetitle4")}
                        <label style={{ fontWeight: "bold", color: "black", marginBottom: "0px" }}>{objectDto.fullName}</label>
                        {t("homepagetitle5")}<br />
                        {t("homepagetitle6")}
                    </label>
                </div>
            </div>
        </div>
    );
};

export default CustomerInfo;